// Turbolinks shims
import {setup as setupTurbolinksReload} from '../src/shims/turbolinks-reload';

// Component manager
import {initialize as initializeComponents} from '../src/lobby/lobby-component-manager';

// Make sure that the tracker doesn’t start before
// configuring it when the DOM is ready.
if (window.ahoy) window.ahoy.configure({startOnReady: false});

setupTurbolinksReload();

initializeComponents();

const appVersion = window.Academos.appVersion;
window.console.log(`Lobby v${appVersion}`);
